import React from 'react';
import logo from '../images/logo1.png';
import { Link } from 'react-router-dom';

export default function Navbar() {

    setInterval(boxShadowAdd, 0.01);

    function onLoadNav() {
        if (window.matchMedia("(max-width: 500px)").matches) {
            isSmall();
            console.log("in");
        }
        else {
            isBig();
        }
    }

    function isSmall() {
        let hamburg_icon = document.getElementById('hamburg_icon');
        let nav = document.querySelector('.nav_list');

        let lines = document.getElementsByClassName('lines');
        console.log("Responsive Connected");

        hamburg_icon.classList.add('display_flex');
        hamburg_icon.classList.remove('display_none');
        nav.classList.add('display_none');

        hamburg_icon.addEventListener('click', () => {
            nav.classList.toggle('display_none');
            nav.classList.toggle('nav_responsive');
            for (let i = 0; i < 3; i++) {
                lines[i].classList.toggle('line' + (i + 1) + '_open');
            }
        });

    }

    function isBig() {
        let hamburg_icon = document.getElementById('hamburg_icon');
        let nav = document.querySelector('nav');

        hamburg_icon.classList.remove('display_flex');
        nav.classList.remove('display_none');
    }

    function boxShadowAdd() {
        let nav = document.getElementById('nav');

        if (document.documentElement.scrollTop > 0) {
            nav.style.boxShadow = '0px 10px 100px var(--primary)';
        }
        else {
            nav.style.boxShadow = '';
        }
    }

    return (
        <>
            <div id="home_top"></div>
            <header>
                <nav id="nav" onLoad={onLoadNav}>
                    <div className="nav_images">
                        <img className="logo_1" src={logo} alt="" />
                        <Link to="/" className="nav_logo_link">
                            <div className="nav_logo_text">
                                <span className="logo_heading">Chrissron</span>
                                <span className="logo_sub_heading">Biomass Solutions Pvt. Ltd.</span>
                            </div>
                        </Link>
                    </div>
                    <ul className="nav_list display_flex">
                        <li className="nav_items"><Link to="/" className="nav_links">Home</Link></li>
                        <li className="nav_items"><Link to="/bioplastics" className="nav_links">Bioplastics</Link></li>
                        <li className="nav_items"><Link to="/about" className="nav_links">About</Link></li>
                        <li className="nav_items"><Link to="mailto:agrimass1985@gmail.com" id="contact_us">Contact us</Link></li>
                    </ul>
                    <div id="hamburg_icon" className="hamburg_icon display_none">
                        <div className="lines line1_close" id="line1"></div>
                        <div className="lines line2_close" id="line2"></div>
                        <div className="lines line3_close" id="line3"></div>
                    </div>
                </nav>
            </header>
        </>
    )
}
